<template>
    <div class="container mt-5">
        <div class="card">
            <div class="card-header">
                Odontólogos Tratantes
                <div class="btn-group float-right" role="group" aria-label="Second group">
                    <a href="https://rnpi.superdesalud.gob.cl" target="_blank" class="btn btn-success">Super Intendencia de Salud</a>
                    <a href="/static/Solicitud-2016.pdf" target="blank" class="btn btn-primary">
                        <i class="fa fa-file"></i> Formulario
                    </a>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="dentists.length > 0">
                    <table class="table table-bordered table-condensed">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-nowrap">
                                  Nombre
                                  <i v-if="order_by === 3" @click="order_by = -3" class="fa fa-sort-amount-asc i-pointer"></i>
                                  <i v-else-if="order_by === -3" @click="order_by = 3" class="fa fa-sort-amount-desc i-pointer"></i>
                                  <i v-else class="fa fa-sort i-pointer" @click="order_by = 3"></i>
                                </th>
                                <th class="text-nowrap">
                                  Especialidad
                                  <i v-if="order_by === 7" @click="order_by = -7" class="fa fa-sort-amount-asc i-pointer"></i>
                                  <i v-else-if="order_by === -7" @click="order_by = 7" class="fa fa-sort-amount-desc i-pointer"></i>
                                  <i v-else class="fa fa-sort i-pointer" @click="order_by = 7"></i>
                                </th>
                                <th>DIRECCION</th>
                                <th>N° TELEFONO</th>
                                <th>Página Web</th>
                            </tr>
                            <tr v-for="dentist in dentists">
                                <td>
                                    <img :src="dentist.image" width="80" height="60" />
                                </td>
                                <td>{{ dentist.name }}</td>
                                <td>{{ dentist.specialty }}</td>
                                <td>{{ dentist.address }}</td>
                                <td>{{ dentist.phone }}</td>
                                <td>{{ dentist.website }}</td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import config from '../config/index';
export default {
    data() {
        return {
            dentists: [],
            order_by: 3,
        }
    },
    created() {
        this.index();
    },
    watch: {
        order_by: function (val) {
            this.index();
        }
    },
    methods: {
        index() {
            axios.get(config.urlBase+'/api/v1/public/dentists', {params: {'order_by': this.order_by}})
            .then((res) => {
                this.dentists = res.data.data;
            }).catch((err) => {
                console.error(err);
            });

        }
    }
}
</script>

<style scoped>
.i-pointer{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SupervisorComponent.vue